import React, { useContext } from 'react';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  LayoutContainer,
  Layout,
  StepContainer,
  SaveBlocker,
  DefaultTemplate,
  CancelWizardDialog,
} from '@bingads-webui-fluent-component/wizard';

import { LinkedInStepFooter } from './step-footer';

export const SingleStepLayoutContainer = () => {
  const i18n = useContext(I18nContext);
  return (
    <LayoutContainer template={DefaultTemplate}>
      <Layout type="StepContainer" component={StepContainer} />
      <Layout type="CancelDialog" component={CancelWizardDialog} />
      <Layout
        type="Footer"
        component={LinkedInStepFooter}
        nextButtonText={i18n.getString('Save and exit')}
        showTermsAndConditions={false}
      />
      <Layout type="Blocker" component={SaveBlocker} />
    </LayoutContainer>
  );
};
